/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    purpose: {
      type: 'variant',
      values: [ 'offer', 'default', 'editorial', 'subtle' ]
    },
    wrap: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { purpose: 'editorial' },
      tokens: { backgroundColor: '#cdcfd5', fontColor: '#394056' }
    },
    {
      if: { purpose: 'offer' },
      tokens: { backgroundColor: '#394056' }
    },
    {
      if: { purpose: 'subtle' },
      tokens: { backgroundColor: '#394056' }
    },
    {
      if: { wrap: true },
      tokens: {
        borderRadius: null,
        borderRadiusBottomLeft: 8,
        borderRadiusBottomRight: 8,
        paddingBottom: 6,
        paddingTop: 6
      }
    }
  ],
  tokens: {
    backgroundColor: '#394056',
    borderRadius: 50,
    borderRadiusBottomLeft: null,
    borderRadiusBottomRight: null,
    boxShadowColor: null,
    boxShadowPaddingBottom: null,
    boxShadowPaddingLeft: null,
    boxShadowPaddingRight: null,
    boxShadowPaddingTop: null,
    curveAfterBackgroundColor: null,
    curveAfterHeight: null,
    curveAfterRadius: null,
    curveAfterWidth: null,
    curveBackgroundColor: null,
    curveHeight: null,
    curveMarginTop: null,
    curveWidth: null,
    fontColor: '#ffffff',
    fontName: 'SofiaPro',
    fontSize: 14,
    fontWeight: '700',
    gradient: null,
    lineHeight: 1.4285714285714286,
    paddingBottom: 2,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 2
  }
}
export default theme
